import styled from 'styled-components'

export const InputWrapper = styled.div`
  margin: 16px;
`

export const SpaceBetweenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: space-between;
`
